module.exports = __webpack_public_path__ + "static/img/rule30.e737956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/matlab/images/rule30.jpg
// module id = HB0a
// module chunks = 1